import React, { useEffect, useState } from 'react';

const loaderContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#0d1117',
};

const loadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100px',
    height: '100px',
    gap: '6px',
};

const spanStyle = {
    width: '30px',
    borderRadius: '50%',
    height: '100px',
    animation: 'scale 1.5s ease-in-out infinite',
};

const Loader = () => (
    <div style={loaderContainerStyle}>
        <div style={loadingStyle}>
            <span style={{ ...spanStyle, backgroundColor: '#ff0000', animationDelay: '-1.6s' }} /> {/* Red */}
            <span style={{ ...spanStyle, backgroundColor: '#ff7f00', animationDelay: '-1.4s' }} /> {/* Orange */}
            <span style={{ ...spanStyle, backgroundColor: '#ffff00', animationDelay: '-1.2s' }} /> {/* Yellow */}
            <span style={{ ...spanStyle, backgroundColor: '#00ff00', animationDelay: '-1s' }} /> {/* Green */}
            <span style={{ ...spanStyle, backgroundColor: '#0000ff', animationDelay: '-0.8s' }} /> {/* Blue */}
            <span style={{ ...spanStyle, backgroundColor: '#4b0082', animationDelay: '-0.6s' }} /> {/* Indigo */}
            <span style={{ ...spanStyle, backgroundColor: '#8b00ff', animationDelay: '-0.4s' }} /> {/* Violet */}
        </div>
        <style>
            {`
                @keyframes scale {
                    0%, 50%, 100% {
                        transform: scaleY(0.05);
                    }
                    25%, 75% {
                        transform: scaleY(1);
                    }
                }
            `}
        </style>
    </div>
);

export default Loader;
